export default "<p>social-media-management works!</p>\r\n"